export enum FILTER_NAMES {
  AirlineChooserStandardFilter = "AirlineChooserStandardFilter",
  OrderItemsInOrderFilter = "OrderItemsInOrderFilter",
  OrderItemsPreviewFilter = "OrderItemsPreviewFilter",
  OrdersFilter = "OrderListStandardFilter",
  OrdersToMergeFilter = "OrdersToMergeFilter",
  DocumentsFilter = "DocumentListStandardFilter",
  DocumentChooserStandardFilter = "DocumentChooserStandardFilter",
  BookingsFilter = "BookingListStandardFilter",
  CostDocumentListStandardFilter = "CostDocumentListStandardFilter",
  CostDocumentImportBookingFiles = "ImportBookingFilesFilter",
  CreditCardStatementsFilter = "CreditCardStatementsFilter",
  CreditCardStatementItemsFilter = "CreditCardStatementItemsFilter",
  ContractorChooserStandardFilter = "ContractorChooserStandardFilter",
  ContractorChooserWithTraderFilter = "ContractorChooserWithTraderFilter",
  ContractorChooserBuyersFilter = "ContractorChooserBuyersFilter",
  ContractorChooserBuyersWithoutLockedFilter = "ContractorChooserBuyersWithoutLockedFilter",
  ContractorChooserSellersFilter = "ContractorChooserSellersFilter",
  ContractorChooserSellersWithoutLockedFilter = "ContractorChooserSellersWithoutLockedFilter",
  ContractorChooserProviderFilter = "ContractorChooserProviderFilter",
  ContractorChooserProviderWithoutLockedFilter = "ContractorChooserProviderWithoutLockedFilter",
  BookingDownloadPdfFilter = "BookingDownloadPdfFilter",
  AdvanceDocumentListStandardFilter = "AdvanceDocumentListStandardFilter",
  CostDocumentItemsToPairStandardFilter = "CostDocumentItemsToPairStandardFilter",
  UserFilter = "UserFilter",
  AttributePrototypeListFilter = "AttributePrototypeListFilter",
  AttributeTemplateListFilter = "AttributeTemplateListFilter",
  ServiceTypeSaleListFilter = "ServiceTypeSaleListFilter",
  ServiceTypeListFilter = "ServiceTypeListFilter",
  ServiceTypeCostFilter = "ServiceTypeCostFilter",
  ServiceTypeSaleFilter = "ServiceTypeSaleFilter",
  ServiceTypeFilter = "ServiceTypeFilter",
  ServiceTypeGroupFilter = "ServiceTypeGroupFilter",
  ServiceTypeGroupItemFilter = "ServiceTypeGroupItemFilter",
  ServiceTypeForDocumentTypeFilter = "ServiceTypeForDocumentTypeFilter",
  AttributeMapperFilter = "AttributeMapperFilter",
  DocumentToPrintFilter = "DocumentToPrintFilter",
  BankAccountContractorFilter = "BankAccountContractorFilter",
  TaskSchedulerStandardFilter = "TaskSchedulerStandardFilter",
  BookingServiceStandardFilter = "BookingServiceStandardFilter",
  BookingServiceCancellationFilter = "BookingServiceCancellationFilter",
  BookingDataListStandardFilter = "BookingDataListStandardFilter",
  BookkeepingStandardFilter = "BookkeepingCloseMonthFilter",
  OptimaExportCashReportStandardFilter = "OptimaExportCashReportStandardFilter",
  OptimaExportInvoicesAndTransfersStandardFilter = "OptimaExportInvoicesAndTransfersStandardFilter",
  OptimaExportCostInvoiceStandardFilter = "OptimaExportCostInvoiceStandardFilter",
  OptimaExportCreditCardsTransfersStandardFilter = "OptimaExportCreditCardsTransfersStandardFilter",
  OptimaExportSaleAsCostInvoicesStandardFilter = "OptimaExportSaleAsCostInvoicesStandardFilter",
  OptimaExportVatMarginStandardFilter = "OptimaExportVatMarginStandardFilter",
  OptimaExportSalesInvoiceAsPurchaseInvoiceFilter = "OptimaExportSalesInvoiceAsPurchaseInvoiceFilter",
  SymfoniaExportCostInvoiceStandardFilter = "SymfoniaExportCostInvoiceStandardFilter",
  SymfoniaExportSaleInvoiceStandardFilter = "SymfoniaExportSaleInvoiceStandardFilter",
  JPKExportStandardFilter = "JPKExportStandardFilter",
  SalesDocumentsStandardFilter = "SalesDocumentsStandardFilter",
  SaleReportStandardFilter = "SaleReportStandardFilter",
  ServiceTypesSalesStandardFilter = "ServiceTypesSalesStandardFilter",
  CashierSaleStandardFilter = "CashierSaleStandardFilter",
  AdvanceInvoiceOutstandingStandartFilter = "AdvanceInvoiceOutstandingStandartFilter",
  SalesServicesStandardFiltert = "SalesServicesStandardFilter",
  SalesServicesFromDocumentStandardFiltert = "SalesServicesFromDocumentStandardFilter",
  SalesServicesCostFiltert = "SalesServicesCostFilter",
  SalesDocumentServiceDistributionFilter = "SalesDocumentServiceDistributionFilter",
  CashierListServicesSoldStandardFilter = "CashierListServicesSoldStandardFilter",
  BankAccountSalesDocumentsFilter = "BankAccountSalesDocumentsFilter",
  ReceiptDocumentsFilter = "ReceiptDocumentsFilter",
  ExportDocumentsFilter = "ExportDocumentsFilter",
  BookingsSoldStandardFilter = "BookingsSoldStandardFilter",
  BookingsSoldStandardHotelFilter = "BookingsSoldStandardHotelFilter",
  ContractorsTurnoverStandardFilter = "ContractorsTurnoverStandardFilter",
  ContractorPaymentsHistoryStandardFilter = "ContractorPaymentsHistoryStandardFilter",
  SalesReservationPrismFilter = "SalesReservationPrismFilter",
  ContractorDiscountStandardFilter = "ContractorDiscountStandardFilter",
  IntegrationSettingsFilter = "IntegrationSettingsFilter",
  InvoiceMailNotyficationStatusFilter = "InvoiceMailNotyficationStatusFilter",
  MonthlyTurnoverStandardFilter = "MonthlyTurnoverStandardFilter",
  MBankFactoringStandardFilter = "MBankFactoringStandardFilter",
  BNPParibasFactoringStandardFilter = "BNPParibasFactoringStandardFilter",
  ArrearsStandardFilter = "ArrearsStandardFilter",
  OutstandingPaymentsStandardFilter = "OutstandingPaymentsStandardFilter",
  ListOfSalesDocumentsStandardFilter = "ListOfSalesDocumentsStandardFilter",
  OutstandingAdvancesStandardFilter = "OutstandingAdvancesStandardFilter",
  PaymentsTransferUnpairedStandardStandardFilter = "PaymentsTransferUnpairedStandardStandardFilter",
  VindicationSentEmailsStandardFilter = "VindicationSentEmailsStandardFilter",
  AirTicketsStandardFilter = "AirTicketsStandardFilter",
  BSPTicketsStandardFilter = "BSPTicketsStandardFilter",
  BSPGeneratorReportsFilter = "BSPGeneratorReportsFilter",
  AirTicketsSoldExtendedFilter = "AirTicketsSoldExtendedFilter",
  SalesReportOfAirTicketsStandardFilter = "SalesReportOfAirTicketsStandardFilter",
  UninvoicedTicketsStandardFilter = "UninvoicedTicketsStandardFilter",
  UninvoicedBookingStandardFilter = "UninvoicedBookingsStandardFilter",
  AirTicketsCanceledStandardFilter = "AirTicketsCanceledStandardFilter",
  CashierProfitStandardFilter = "CashierProfitStandardFilter",
  CashierPaymentsDueStandardFilter = "CashierPaymentsDueStandardFilter",
  ProfitStandardFilter = "ProfitStandardFilter",
  TravelServicesStandardFilter = "TravelServicesStandardFilter",
  TravelGroupedServiceStandardFilter = "TravelGroupedServiceStandardFilter",
  CostDocumentsCostDifferencesFilter = "CostDocumentsCostDifferencesFilter",
  CostDocumentsNotPairedInvoicesFilter = "CostDocumentsNotPairedInvoicesFilter",
  CostDocumentsPurchasePriceDifferenceFilter = "CostDocumentsPurchasePriceDifferenceFilter",
  CostDocumentsNotSetledSaleDocumentItemFilter = "CostDocumentsNotSetledSaleDocumentItemFilter",
  CostDocumentItemNotSetledFilter = "CostDocumentItemNotSetledFilter",
  PairedSaleDocumentWithCostDocumentFilter = "PairedSaleDocumentWithCostDocumentFilter",
  CompareTicketsStandardFilter = "CompareTicketsStandardFilter",
  BankAccountFilter = "BankAccountFilter",
  BankAccountAssignFilter = "BankAccountAssignFilter",
  BankAccountExportConfigurationFilter = "BankAccountExportConfigurationFilter",
  ExchangeRateStandard = "ExchangeRateListStandardFilter",
  ExchangeRateAdditional = "ExchangeRateListAdditionalFilter",
  PrinterCommandStandardFilter = "PrinterCommandStandardFilter",
  BankStatementItemStandardFilter = "BankStatementItemStandardFilter",
  BankStatementItemPurchaseStandardFilter = "BankStatementItemPurchaseStandardFilter",
  CashReportsStandardFilter = "CashReportsStandardFilter",
  ContractorSettlementDocumentStandardFilter = "ContractorSettlementDocumentStandardFilter",
  ContractorSettlementPaymentsStandardFilter = "ContractorSettlementPaymentsStandardFilter",
  CashReportDocumentsStandardFilter = "CashReportDocumentsStandardFilter",
  DocumentsForStatementsStandardFilter = "DocumentsForStatementsStandardFilter",
  BookingsForStatementsStandardFilter = "BookingsForStatementsStandardFilter",
  BankStatementStandardFilter = "BankStatementStandardFilter",
  NotSettledDocumentStandardFilter = "NotSettledDocumentStandardFilter",
  ContractorServiceTypesAttributesFilter = "ContractorServiceTypesAttributesFilter",
  WorkFlowListFilter = "WorkFlowListFilter",
  BSPReportStandardFilter = "BSPReportStandardFilter",
  BSPBookingItemStandardFilter = "BSPBookingItemStandardFilter",
  RequestForPaymentFilter = "RequestForPaymentFilter",
  MailHistoryFilter = "MailHistoryFilter",
  MailBoxFilter = "MailBoxFilter",
  SalesDocumentPurchaseNetStandardFilter = "SalesDocumentPurchaseNetStandardFilter",
  TouristModuleFilter = "TouristModuleFilter",
  TodoFilterName = "TODO",
  AirlineStandardFilter = "AirlineStandardFilter",
  CreditCardsFilter = "CreditCardStandardFilter",
  DocumentTypeFilter = "DocumentTypeFilter",
  ExportItemDeveloperFilter = "ExportItemDeveloperFilter",
  SettlementStandardFilter = "SettlementStandardFilter",
  StandingOrdersFilter = "StandingOrdersFilter",
  StandingOrderItemsFilter = "StandingOrderItemsFilter",
  BookingReportItemStandardFilter = "BookingReportItemStandardFilter",
  BookingItemListStandardFilter = "BookingItemListStandardFilter",
  CostHintFilter = "CostHintFilter",
  CostDocumentOtherStandardFilter = "CostDocumentOtherStandardFilter",
  CostDocumentBuforStandardFilter = "CostDocumentBuforStandardFilter",
  CommercialCostStandardFilter = "CommercialCostStandardFilter",
  ContractStandardFilter = "ContractStandardFilter",
  ContractComponentStandardFilter = "ContractComponentStandardFilter",
  ContractByContractorFilter = "ContractByContractorFilter",
  CommercialContractStandardFilter = "CommercialContractStandardFilter",
  CommercialContractComponentStandardFilter = "CommercialContractComponentStandardFilter",
  CommercialContractByContractorFilter = "CommercialContractByContractorFilter",
}
